import React, { useContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";
import { renderToStaticMarkup } from 'react-dom/server';

// Import Swiper styles
import "swiper/css";
import "swiper/css/effect-fade";
import "swiper/css/navigation";
import "swiper/css/pagination";

import "./home.css";
import {
  QueryClient,
  QueryClientProvider,
  useMutation,
  useQuery,
  useQueryClient,
} from "react-query";

// import soru ile compenant soru sirasinin aynı olması onemli yoksa slayt bozuluyor
import Carousel from "../components/Carousel";

import { EffectFade, Navigation, Pagination, Keyboard } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";


const Colchicum = () => {
  const [posts, setPosts] = useState([]);
  //const [postsh, setPostsh] = useState([]);
  const [sonuc02goster, setSonuc02] = useState([]);

  const [sonuc04goster, setSonuc04] = useState([]);

  const [sonuc05goster, setSonuc05] = useState([]);
  const [sonuc06goster, setSonuc06] = useState([]);

  const [sonuc07goster, setSonuc07] = useState([]);

  const [sonuc08goster, setSonuc08] = useState([]);
  const [sonuc09goster, setSonuc09] = useState([]);

  const [sonuc10goster, setSonuc10] = useState([]);
  const [sonuc11goster, setSonuc11] = useState([]);
  const [sonuc12goster, setSonuc12] = useState([]);


  const location = useLocation();
  const postId = location.pathname.split("/")[2];
  const records = posts.slice();
  //const recordsh = postsh.slice();
  const sonuc19 = 30;
  const sonuc24 = 30;
  const sonuc11 = 30;

  useEffect(() => {
  
  // sunum bilgileri
    const fetchData = async () => {
      //console.log("use effect home calisti");
      try {
        //console.log("postId", postId);
        const res = await axios.get(
          `https://api.recordatifocus.com/sunum-bilgileri/${postId}`
        );
        //console.log("res", res.data);
        setPosts(res.data);
      } catch (err) {
        console.log(err);
      }
    };
    fetchData();
// sunum bilbileri
// 
// Soru 01
    const soruBir = async () => {
      const postId = location.pathname.split("/")[2];

      //console.log("postId", postId);
      const url = `https://api.recordatifocus.com/colchicum-sonuc-01/${postId}`;
      const res = await fetch(url);
      const data = await res.json();
      let outputData = data.map((item) => {
        return {
          cevap: parseInt(item.cevap),
        };
      });
      //console.log(outputData);
      const result = Object.values(outputData).reduce(
        (r, { cevap }) => r + cevap,
        0
      );
      //console.log(result);
      const longeur = data.length;
      //console.log(longeur);
      //setPostsh(data);
      //console.log((result*100)/longeur);

      let sonuc;

      if (longeur === 0) {
            sonuc = 100;
      } else {
            sonuc = 100 - (result * 100) / longeur;
      }

      console.log("Soru01 yanlis orani:", sonuc);

      if (sonuc >= sonuc19) {
      	const sonuc02goster = <div><img className="img-fluid" src="https://slide.recordatifocus.com/upload/colchicum/Colchicum_Dispert_DocFocus_HAZIRAN26_Page_02_soru_01.jpg"/></div>;
      	setSonuc02(sonuc02goster);
        
        //console.log(sonuc01goster);
      } else {
      	const sonuc02goster = null;
      	setSonuc02(sonuc02goster);
      }
    };
  
    soruBir();

    
// soru 01
// 
// Soru 02
    const soruIki = async () => {
      const postId = location.pathname.split("/")[2];

      //console.log("postId", postId);
      const url = `https://api.recordatifocus.com/colchicum-sonuc-02/${postId}`;
      const res = await fetch(url);
      const data = await res.json();
      let outputData = data.map((item) => {
        return {
          cevap: parseInt(item.cevap),
        };
      });
      //console.log(outputData);
      const result = Object.values(outputData).reduce(
        (r, { cevap }) => r + cevap,
        0
      );
      //console.log(result);
      const longeur = data.length;
      //console.log(longeur);
      //setPostsh(data);
      //console.log((result*100)/longeur);

      let sonuc;

      if (longeur === 0) {
            sonuc = 100;
      } else {
            sonuc = 100 - (result * 100) / longeur;
      }

      console.log("Soru02 yanlis orani:", sonuc);

      if (sonuc >= sonuc19) {
      	const sonuc04goster = <div><img className="img-fluid" src="https://slide.recordatifocus.com/upload/colchicum/Colchicum_Dispert_DocFocus_HAZIRAN26_Page_04_soru_02.jpg"/></div>;
      	setSonuc04(sonuc04goster);        
        //console.log(sonuc01goster);
      } else {
      	const sonuc04goster = null;
      	setSonuc04(sonuc04goster);
      }
    };
  
    soruIki();

    
// soru 02
// 
// 

// Soru 03
    const soruUc = async () => {
      const postId = location.pathname.split("/")[2];

      //console.log("postId", postId);
      const url = `https://api.recordatifocus.com/colchicum-sonuc-03/${postId}`;
      const res = await fetch(url);
      const data = await res.json();
      let outputData = data.map((item) => {
        return {
          cevap: parseInt(item.cevap),
        };
      });
      const result = Object.values(outputData).reduce(
        (r, { cevap }) => r + cevap,
        0
      );
      console.log("Soru03 result yanlis orani:",result);
      const longeur = data.length;
      console.log("Soru03 longeur yanlis orani:", longeur);
      //setPostsh(data);
      //console.log((result*100)/longeur);

      let sonuc;

      if (longeur === 0) {
            sonuc = 100;
      } else {
            sonuc = 100 - (result * 100) / longeur;
      }


      console.log("Soru03 yanlis orani:", sonuc);

      if (sonuc >= sonuc19) {
      	const sonuc05goster = <div><img className="img-fluid" src="https://slide.recordatifocus.com/upload/colchicum/Colchicum_Dispert_DocFocus_HAZIRAN26_Page_05_soru_03.jpg"/></div>;
        const sonuc06goster = <div><img className="img-fluid" src="https://slide.recordatifocus.com/upload/colchicum/Colchicum_Dispert_DocFocus_HAZIRAN26_Page_06_soru_03.jpg"/></div>;
      	setSonuc05(sonuc05goster);
      	setSonuc06(sonuc06goster);
        
        //console.log(sonuc01goster);
      } else {
      	const sonuc05goster = null;
      	const sonuc06goster = null;
      	setSonuc05(sonuc05goster);
      	setSonuc06(sonuc06goster);
      }
    };
  
    soruUc();

    
// soru 03
// 


// 
// Soru 04
    const soruDort = async () => {
      const postId = location.pathname.split("/")[2];

      //console.log("postId", postId);
      const url = `https://api.recordatifocus.com/colchicum-sonuc-04/${postId}`;
      const res = await fetch(url);
      const data = await res.json();
      let outputData = data.map((item) => {
        return {
          cevap: parseInt(item.cevap),
        };
      });
      //console.log(outputData);
      const result = Object.values(outputData).reduce(
        (r, { cevap }) => r + cevap,
        0
      );
      //console.log(result);
      const longeur = data.length;
      //console.log(longeur);
      //setPostsh(data);
      //console.log((result*100)/longeur);

      let sonuc;

      if (longeur === 0) {
            sonuc = 100;
      } else {
            sonuc = 100 - (result * 100) / longeur;
      }

      console.log("Soru04 yanlis orani:", sonuc);

      if (sonuc >= sonuc19) {
      	const sonuc07goster = <div><img className="img-fluid" src="https://slide.recordatifocus.com/upload/colchicum/Colchicum_Dispert_DocFocus_HAZIRAN26_Page_07_soru_04.jpg"/></div>;
      	setSonuc07(sonuc07goster);
        
        //console.log(sonuc01goster);
      } else {
      	const sonuc07goster = null;
      	setSonuc07(sonuc07goster);
      }
    };
  
    soruDort();

    
// soru 04
// 

// 
// Soru 05
    const soruBes = async () => {
      const postId = location.pathname.split("/")[2];

      //console.log("postId", postId);
      const url = `https://api.recordatifocus.com/colchicum-sonuc-05/${postId}`;
      const res = await fetch(url);
      const data = await res.json();
      let outputData = data.map((item) => {
        return {
          cevap: parseInt(item.cevap),
        };
      });
      //console.log(outputData);
      const result = Object.values(outputData).reduce(
        (r, { cevap }) => r + cevap,
        0
      );
      //console.log(result);
      const longeur = data.length;
      //console.log(longeur);
      //setPostsh(data);
      //console.log((result*100)/longeur);

      let sonuc;

      if (longeur === 0) {
            sonuc = 100;
      } else {
            sonuc = 100 - (result * 100) / longeur;
      }

      console.log("Soru05 yanlis orani:", sonuc);

      if (sonuc >= sonuc19) {
      	const sonuc08goster = <div><img className="img-fluid" src="https://slide.recordatifocus.com/upload/colchicum/Colchicum_Dispert_DocFocus_HAZIRAN26_Page_08_soru_05.jpg"/></div>;
        const sonuc09goster = <div><img className="img-fluid" src="https://slide.recordatifocus.com/upload/colchicum/Colchicum_Dispert_DocFocus_HAZIRAN26_Page_09_soru_05.jpg"/></div>;
      	setSonuc08(sonuc08goster);
      	setSonuc09(sonuc09goster);
        
        //console.log(sonuc01goster);
      } else {
      	const sonuc08goster = null;
      	const sonuc09goster = null;
      	setSonuc08(sonuc08goster);
      	setSonuc09(sonuc09goster);
      }
    };
  
    soruBes();

    


// Soru 08
    const soruAlti = async () => {
      const postId = location.pathname.split("/")[2];

      //console.log("postId", postId);
      const url = `https://api.recordatifocus.com/colchicum-sonuc-06/${postId}`;
      const res = await fetch(url);
      const data = await res.json();
      let outputData = data.map((item) => {
        return {
          cevap: parseInt(item.cevap),
        };
      });
      //console.log(outputData);
      const result = Object.values(outputData).reduce(
        (r, { cevap }) => r + cevap,
        0
      );
      //console.log(result);
      const longeur = data.length;
      //console.log(longeur);
      //setPostsh(data);
      //console.log((result*100)/longeur);

      let sonuc;

      if (longeur === 0) {
            sonuc = 100;
      } else {
            sonuc = 100 - (result * 100) / longeur;
      }

      console.log("Soru08 yanlis orani:", sonuc);

      if (sonuc >= sonuc19) {
      	const sonuc10goster = <div><img className="img-fluid" src="https://slide.recordatifocus.com/upload/colchicum/Colchicum_Dispert_DocFocus_HAZIRAN26_Page_10_soru_06.jpg"/></div>;
        const sonuc11goster = <div><img className="img-fluid" src="https://slide.recordatifocus.com/upload/colchicum/Colchicum_Dispert_DocFocus_HAZIRAN26_Page_11_soru_06.jpg"/></div>;
        const sonuc12goster = <div><img className="img-fluid" src="https://slide.recordatifocus.com/upload/colchicum/Colchicum_Dispert_DocFocus_HAZIRAN26_Page_12_soru_06.jpg"/></div>;
      	setSonuc10(sonuc10goster);
      	setSonuc11(sonuc11goster);
      	setSonuc12(sonuc12goster);
        
        //console.log(sonuc01goster);
      } else {
      	const sonuc10goster = null;
      	const sonuc11goster = null;
      	const sonuc12goster = null;
      	setSonuc10(sonuc10goster);
      	setSonuc11(sonuc11goster);
      	setSonuc12(sonuc12goster);
      }
    };
  
    soruAlti();

    
// soru 08
// 


// 
// Soru 02
// soru 12
// 
// 
// 

  
  
  }, [postId]);


const slide01goster = <div><img className="img-fluid" src="https://slide.recordatifocus.com/upload/colchicum/Colchicum_Dispert_DocFocus_HAZIRAN26_Page_01.jpg"/></div>;
const slide02goster = sonuc02goster;
const slide03goster = <div><img className="img-fluid" src="https://slide.recordatifocus.com/upload/colchicum/Colchicum_Dispert_DocFocus_HAZIRAN26_Page_03.jpg"/></div>;
const slide04goster = sonuc04goster;
const slide05goster = sonuc05goster;
const slide06goster = sonuc06goster;
const slide07goster = sonuc07goster;
const slide08goster = sonuc08goster;
const slide09goster = sonuc09goster;
const slide10goster = sonuc10goster;
const slide11goster = sonuc11goster;
const slide12goster = sonuc12goster;
const slide13goster = <div><img className="img-fluid" src="https://slide.recordatifocus.com/upload/colchicum/Colchicum_Dispert_DocFocus_HAZIRAN26_Page_13.jpg"/></div>;
const slide14goster = <div><img className="img-fluid" src="https://slide.recordatifocus.com/upload/colchicum/Colchicum_Dispert_DocFocus_HAZIRAN26_Page_14.jpg"/></div>;
const slide15goster = <div><img className="img-fluid" src="https://slide.recordatifocus.com/upload/colchicum/Colchicum_Dispert_DocFocus_HAZIRAN26_Page_15.jpg"/></div>;
const slide16goster = <div><img className="img-fluid" src="https://slide.recordatifocus.com/upload/colchicum/Colchicum_Dispert_DocFocus_HAZIRAN26_Page_16.jpg"/></div>;
const slide17goster = <div><img className="img-fluid" src="https://slide.recordatifocus.com/upload/colchicum/Colchicum_Dispert_DocFocus_HAZIRAN26_Page_17.jpg"/></div>;
const slide18goster = <div><img className="img-fluid" src="https://slide.recordatifocus.com/upload/colchicum/Colchicum_Dispert_DocFocus_HAZIRAN26_Page_18.jpg"/></div>;
const slide19goster = <div><img className="img-fluid" src="https://slide.recordatifocus.com/upload/colchicum/Colchicum_Dispert_DocFocus_HAZIRAN26_Page_19.jpg"/></div>;
const slide20goster = <div><img className="img-fluid" src="https://slide.recordatifocus.com/upload/colchicum/Colchicum_Dispert_DocFocus_HAZIRAN26_Page_20.jpg"/></div>;
const slide21goster = <div><img className="img-fluid" src="https://slide.recordatifocus.com/upload/colchicum/Colchicum_Dispert_DocFocus_HAZIRAN26_Page_21.jpg"/></div>;

const slides = [slide01goster, slide02goster, slide03goster, slide04goster, slide05goster, slide06goster, slide07goster, slide08goster, slide09goster, slide10goster, slide11goster, slide12goster, slide13goster, slide14goster, slide15goster, slide16goster, slide17goster, slide18goster, slide19goster, slide20goster, slide21goster];
var filtered = slides.filter(Boolean);
const listItems = filtered.map((number) =>  <SwiperSlide>{number}</SwiperSlide>);

  return (
    <>
      <Swiper
        effect={"fade"}
        pagination={{
          type: "fraction",
        }}
        keyboard={{
          enabled: true,
        }}
        navigation={true}
        modules={[EffectFade, Navigation, Pagination, Keyboard]}
        className="mySwiper"
      >
        {listItems}
      </Swiper>
  
      {records.map((post) => (
        <div className="container d-none my-4" key={post.id}>
          <div className="sunum-adi">Sunum Adi: {post.title}</div>
  		  <div className="sunum-adi">Sunum Tarihi: {post.tarih}</div>
  		  <div className="sunum-adi">Sunan Kisi: {post.uid}</div>
        </div>
      ))}

<div className={`col d-flex flex-column align-items-center justify-content-center pb-5 footer-${location.pathname.split("/")[2]}`}>

<div className="card mx-2" style={{width: "6.75rem"}}>
  <a href="https://qr.recordatifocus.com/hippurinkub" className="text-decoration-none text-black" target="_blank"><img alt="" src="https://sorular.recordatifocus.com/sites/api.recordatifocus.com/themes/bootstrap_dofo/images/KUB-COLCHICUM.png" className="img-fluid" /></a>
  <div className="py-1 " style={{backgroundColor: "#655DC6"}}>
    <a href="https://qr.recordatifocus.com/hippurinkub" className="text-decoration-none text-white" target="_blank"><div className="text-center fw-bold">COLCHICUM</div></a>
  </div>
</div>
<p class="pb-5 mx-3 fw-bold footer-link-undefined">www.recordati.com.tr</p>
</div>

  
    </>
  );
};

export default Colchicum;
